import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ExplorerDocument } from 'src/app/core/models/explorer-document';

@Component({
  selector: 'shared-document-card',
  templateUrl: './document-card.component.html',
  styles: [
  ]
})
export class DocumentCardComponent {

  @Input('document')
  public document!: ExplorerDocument;

  @Output('onClickFavoriteEvent')
  public onClickFavoriteEvent: EventEmitter<ExplorerDocument> = new EventEmitter();

  @Output('onClickDownloadEvent')
  public onClickDownloadEvent: EventEmitter<ExplorerDocument> = new EventEmitter();

  @Output('onClickViewEvent')
  public onClickViewEvent: EventEmitter<ExplorerDocument> = new EventEmitter();

  @Output('onClickRelatedAnnexesEvent')
  public onClickRelatedAnnexesEvent: EventEmitter<ExplorerDocument> = new EventEmitter();

  public get icon(): string {
    let css: string = '';

    switch (this.document?.fileExtension) {
      case '.csv':
        css = 'fa-file-csv text-emerald-600';
        break;
      case '.pdf':
        css = 'fa-file-pdf text-red-600';
        break;
      case '.jpg':
      case '.png':
      case '.jpeg':
        css = 'fa-file-image text-sky-600';
        break;
      case '.pptx':
      case '.ppsx':
      case '.odp':
        css = 'fa-file-powerpoint text-orange-600';
        break;
      case '.docx':
        css = 'fa-file-word text-sky-700';
        break;
      case '.xlsx':
        css = 'fa-file-excel text-green-700';
        break;
      default:
        css = 'fa-file text-sky-600';
        break;
    }
    return css;
  }

  public get logoSize(): string {
    let size: string = 'w-32';
    switch (this.document?.brand.name) {
      case 'UVM':
        size = 'w-28';
        break;
      case 'UNITEC':
        size = 'w-28';
        break;
      default:
        break;
    }
    return size;
  }

  /**
   * Emit event when favorite option is clicked.
   */
  public onClickFavoriteHandler(): void {
    this.onClickFavoriteEvent.emit(this.document);
  }

  /**
   * Emit event when view option is clicked.
   */
  public onClickViewHandler(): void {
    this.onClickViewEvent.emit(this.document);
  }

  /**
   * Emit event when download option is clicked.
   */
  public onClickDownloadHandler(): void {
    this.onClickDownloadEvent.emit(this.document);
  }

  /**
   * Emit event when related annexes option is clicked.
   */
  public onClickRelatedAnnexesHandler(): void {
    this.onClickRelatedAnnexesEvent.emit(this.document);
  }
}